import request from '../_network/request'
import secondRequest from '../_network/secondRequest'
import {locationMall, transactionUrl} from '../_helpers'

const checkBalance = (cardNumber, memberType) => {
    return secondRequest({
        url:'router/' + locationMall(memberType) + '/iems/check-balance',
        method: 'POST',
        data: {
            cardNumber : cardNumber
        }
    })
}

// const doPayment = (eWallet, payload, memberType) => {
//     switch (eWallet) {
//         case "Emoney":
//             return request({
//                 url: `/api/salesorder/savetrans`,
//                 method: 'POST',
//                 headers : {
//                     'usr': 'retailsoft',
//                     'token': 'wTvq8TYj3DETVnaCgwrK2dYWrLaERZl+ZnpeWTUYt+8='
//                 },
//                 data: "doc=" + payload
//             })
//         case "Gopay":
//             return secondRequest({
//                 url: `router/${locationMall(memberType)}/midtrans/transaction`,
//                 method: 'POST',
//                 headers : {
//                     'usr': 'retailsoft',
//                     'token': 'wTvq8TYj3DETVnaCgwrK2dYWrLaERZl+ZnpeWTUYt+8=',
//                     'Content-Type' : 'application/json'
//                 },
//                 data: payload
//             })
//         default:
//             break;
//     }
// }

const iemsPayment = (memberType, payload) => {
    return secondRequest({
        url : 'router/' + transactionUrl(memberType),
        method : 'POST',
        data : payload
    })
}

const midtransPayment = (memberType, payload) => {
    return secondRequest({
        url: `router/${locationMall(memberType)}/midtrans/transaction`,
        method : 'POST',
        data : payload
    })
}

const historyPayment = (payload) => {
    return request({
        url: `api/salesorder/findtrans?` + payload,
        method: 'GET',
        headers : {
            'usr': 'retailsoft',
            'token': 'wTvq8TYj3DETVnaCgwrK2dYWrLaERZl+ZnpeWTUYt+8=',
            'Content-Type' : 'application/json'
        }
    })
}

const detailTransaction = (payload) => {
    return request({
        url: '/api/salesorder/findtrans?condition=1&keywords='+ payload +'&fromtemplate=true&keywords=&status=-1',
        method: 'GET',
        headers : {
            'usr': 'retailsoft',
            'token': 'wTvq8TYj3DETVnaCgwrK2dYWrLaERZl+ZnpeWTUYt+8=',
            'Content-Type' : 'application/json'
        }
    })
}

const getVoucher = (cardNumber, memberId, memberType) => {
    return secondRequest({
        url:'router/' + locationMall(memberType) + '/voucher',
        method: 'POST',
        data: {
            cardNumber : cardNumber,
            memberId : memberId
        }
    })
}
export const paymentServices = {
    midtransPayment,
    historyPayment,
    iemsPayment,
    detailTransaction,
    checkBalance,
    getVoucher
}
